import useFeatureIntros, { SEEN_FEATURE_INTROS_KEY } from './use-feature-intros';

export { useFeatureIntros, SEEN_FEATURE_INTROS_KEY };

export default useFeatureIntros;
